import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

// const baseUrl = 'http://192.168.1.8:3000';
const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  workflows: [],
  workflowColaboradores: []
};

const getters = {
  // Workflow
  workflows: state => state.workflows.sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
  workflowsAtivo: state => state.workflows.filter(workflow => workflow.Status.startsWith('A')).sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
  workflowColaboradores: state => state.workflowColaboradores,
}

const actions = {
  // Workflow
  async fetchWorkflows({ commit }) {
    const response = await axios.get(`${baseUrl}/workflows`);
    if (response.data) {
      commit('setWorkflows', response.data);
    } else {
      commit('setWorkflows', []);
    }
  },
  async fetchWorkflowsSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/workflows?idLayoutSql=${args.idLayoutSql}`);
      if (response.data.length) {
        commit('setWorkflows', response.data);
      } else {
        commit('setWorkflows', []);
      }
    } catch (error) {
      commit('setWorkflows', []);
    }
  },
  async addWorkflow({ commit }, workflow) {
    const response = await axios.post(`${baseUrl}/workflows`, workflow);
    workflow.IdWorkflow = response.data.IdWorkflow;
    commit('newWorkflow', workflow);
    return response.data.IdWorkflow;
  },
  async updateWorkflow({ commit }, updWorkflow) {
    await axios.put(`${baseUrl}/workflows`, updWorkflow);
    commit('updateWorkflow', updWorkflow);
  },
  async deleteWorkflow({ commit }, id) {
    await axios.delete(`${baseUrl}/workflows/${id}`);
    commit('removeWorkflow', id);
  },
  // Colaborador
  resetaWorkflowColaboradores({ commit }) {
    commit('resetaWorkflowColaboradores');
  },
  async fetchWorkflowColaboradores({ commit }, { id, atividades }) {
    let response;
    if (atividades) {
      response = await axios.get(`${baseUrl}/workflows/${id}/colaboradores?atividades=true`);
    } else {
      response = await axios.get(`${baseUrl}/workflows/${id}/colaboradores`);
    }
    
    if (response.data.length) {
      commit('setWorkflowColaboradores', response.data);
    } else {
      commit('setWorkflowColaboradores', []);
    }
  },
  async addWorkflowColaborador({ commit }, colaborador) {
    try {
      const response = await axios.post(`${baseUrl}/workflows/${colaborador.IdWorkflow}/colaboradores`, colaborador);
      if (response) {
        commit('newWorkflowColaborador', colaborador);
      }
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async deleteWorkflowColaborador({ commit }, colaborador) {
    await axios.delete(`${baseUrl}/workflows/${colaborador.IdWorkflow}/colaboradores/${colaborador.IdColaborador}`);
    commit('removeWorkflowColaborador', colaborador.IdColaborador);
  },
}

const mutations = {
  // Workflow
  setWorkflows: (state, workflows) => state.workflows = workflows,
  newWorkflow: (state, workflow) => state.workflows.push(workflow),
  removeWorkflow: (state, id) => state.workflows = state.workflows.filter(workflow => workflow.IdWorkflow !== id),
  updateWorkflow: (state, updWorkflow) => {
    const index = state.workflows.findIndex(workflow => workflow.IdWorkflow === updWorkflow.IdWorkflow);
    if (index !== -1) {
      state.workflows.splice(index, 1, updWorkflow);
    }
  },
  // Colaboradores
  resetaWorkflowColaboradores: state => state.workflowColaboradores = [],
  setWorkflowColaboradores: (state, colaboradores) => state.workflowColaboradores = colaboradores,
  newWorkflowColaborador: (state, colaborador) => state.workflowColaboradores.push(colaborador),
  removeWorkflowColaborador: (state, id) => state.workflowColaboradores = state.workflowColaboradores.filter(colaborador => colaborador.IdColaborador !== id),
}

export default {
  state,
  getters,
  actions,
  mutations
}